import { LocationTree } from 'js/model/rainbow/LocationTree';

export type DistanceUnit = 'kilometre' | 'mile';
export type CurrencyFormat =
  | 'symbol_start'
  | 'symbol_end'
  | 'code_start'
  | 'code_end'
  | 'whitespace_symbol'
  | 'symbol_whitespace'
  | 'whitespace_code'
  | 'code_whitespace';

export type LoyaltyAchievement = {
  points: number;
  giftcardAmount: number;
};

export const ORDER_CHALLENGE = 'order';

type LoyaltyOrderChallengeProperties = {
  earnRateDenominator: number;
  earnRateNumerator: number;
  autoCheckoutPeriodInHours: number;
};

type LoyaltyOrderChallenge = Record<
  typeof ORDER_CHALLENGE,
  LoyaltyOrderChallengeProperties
>;

type Loyalty = {
  achievements: LoyaltyAchievement[];
  challenges: LoyaltyOrderChallenge;
};

export interface ChannelOutput {
  code: string;
  availableLanguages: {
    displayName: string;
    code: string;
    primary: boolean;
  }[];
  distanceUnit: DistanceUnit;
  domain: string;
  currencyCode: string;
  decimalSeparator: string;
  currencyFormat: CurrencyFormat;
  country: LocationTree;
  locale: string;
  firstMediaDomain: string;
  type: string;
  channelFeatures: string[];
  connectDomain?: string;
  loyalty?: Loyalty;
}

export interface Channel extends ChannelOutput {
  languageCode: string;
}

export interface ChannelLoyalty extends ChannelOutput {
  loyalty: Loyalty;
}
